import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "rootElement" },
    [
      _setup.filterType !== "home"
        ? [
            !_setup.isAppointmentOn ||
            _setup.lpuWithAppointmentIds.includes(_vm.lpuAddress.lpu.id) ||
            !_setup.selectedItem.isWorkplace
              ? _c("div", [
                  (_setup.hasSlots && _vm.lpuAddress.appointment_on) ||
                  !_setup.selectedItem.isWorkplace
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _setup.isRequestSlotsDone,
                                expression: "isRequestSlotsDone",
                              },
                            ],
                          },
                          [
                            _setup.isMobile
                              ? _c(VDivider, { staticClass: "my-3" })
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.appointmentType === "express" &&
                            _setup.lpuWorkingText
                              ? _c(_setup.LpuNotWorkingLabel, {
                                  staticClass: "mb-3",
                                  attrs: {
                                    "lpu-working-text": _setup.lpuWorkingText,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(_setup.PartCalendar, {
                              attrs: {
                                "lpu-id": _vm.lpuAddress.lpu.id,
                                "appointment-type": _setup.appointmentType,
                                "is-workplace": _setup.isWorkplace,
                                "lpu-working-text": _setup.lpuWorkingText,
                                "lpu-phone":
                                  _vm.lpuAddress.lpu.lpuphone?.phone || "",
                              },
                              on: {
                                "calendar-time-choice":
                                  _setup.handleCalendarTimeChoice,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_setup.isRequestSlotsDone,
                                expression: "!isRequestSlotsDone",
                              },
                            ],
                          },
                          [
                            _c(
                              VSheet,
                              {
                                staticClass:
                                  "d-flex align-center justify-center",
                                attrs: { height: "168" },
                              },
                              [
                                _c(VProgressCircular, {
                                  attrs: {
                                    color: "primary",
                                    size: "48",
                                    indeterminate: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_setup.isMobile &&
                        _setup.isUserStaff &&
                        _vm.lpuAddress.staff_appointment_type
                          ? _c(
                              "div",
                              { staticClass: "staff-appointment-type" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "staff-appointment-type__text",
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.lpuAddress.staff_appointment_type
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _c(
                        "div",
                        [
                          _setup.appointmentWillEnableTime
                            ? _c(
                                VBtn,
                                { attrs: { color: "primary", disabled: "" } },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _setup.t(
                                          "Запись включится",
                                          _setup.options
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                  _c("time", [
                                    _vm._v(
                                      _vm._s(_setup.appointmentWillEnableTime)
                                    ),
                                  ]),
                                ]
                              )
                            : _setup.isAppointmentOn
                            ? [
                                _setup.appointmentType === "express" &&
                                _setup.lpuWorkingText
                                  ? _c(_setup.LpuNotWorkingLabel, {
                                      staticClass: "mb-3",
                                      attrs: {
                                        "lpu-working-text":
                                          _setup.lpuWorkingText,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _setup.appointmentType === "express"
                                  ? _c(_setup.PartCalendar, {
                                      attrs: {
                                        "lpu-id": _vm.lpuAddress.lpu.id,
                                        "appointment-type":
                                          _setup.appointmentType,
                                        "lpu-working-text":
                                          _setup.lpuWorkingText,
                                        "is-workplace": _setup.isWorkplace,
                                        "lpu-phone":
                                          _vm.lpuAddress.lpu.lpuphone?.phone ||
                                          "",
                                      },
                                    })
                                  : !_setup.hasSlots
                                  ? _c(_setup.CalendarStub)
                                  : _c(
                                      VBtn,
                                      {
                                        attrs: {
                                          color: "primary",
                                          depressed: "",
                                          block: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _setup.t(
                                                "Запись на приём",
                                                _setup.options
                                              )
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                ])
              : _vm._e(),
          ]
        : [
            _setup.lpuWorkingText
              ? _c(_setup.LpuNotWorkingLabel, {
                  attrs: { "lpu-working-text": _setup.lpuWorkingText },
                })
              : _vm._e(),
            _vm._v(" "),
            _setup.isMobile && !_setup.lpuWorkingText
              ? [
                  _setup.isPriceGoNumber && !_vm.lpuAddress.appointment_direct
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "text-body-2 text-info--text mb-4" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_setup.description) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            VBtn,
                            {
                              attrs: {
                                color: "primary",
                                depressed: "",
                                block: "",
                                href: `tel:${_setup.mobilePhone}`,
                              },
                            },
                            [
                              _c(VIcon, { staticClass: "mr-2" }, [
                                _vm._v(
                                  "\n            ui-icon-car-clinic\n          "
                                ),
                              ]),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_setup.t("Вызвать", _setup.options)) +
                                  " " +
                                  _vm._s(
                                    _setup.t(
                                      _setup.doctor?.is_medic
                                        ? "врача"
                                        : "специалиста",
                                      _setup.options
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }